export const AUTOENROLLED_COURSES_COOKIE_KEY = 'program-home_AutoenrolledCoursesModal';
export const AUTOENROLLED_COURSES_COOKIE_PATH = '/programs';
export const AUTOJOIN_BANNER_DISMISSED = 'autojoin-banner_dismissed';
